import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { TrafficLineChart } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.component";
import { TrafficSubject } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.helpers";
import { IpDetailContainer } from "../../../../components/subscription-detail/ip-detail-container/ip-detail-container";
import { Networkgraph } from "../../../../components/subscription-detail/networkgraph/networkgraph";
import { PageTabComponent } from "../../../../components/subscription-detail/page-tab/page-tab";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { EnabledPipe } from "../../../../helpers/enabledpipe/enabledpipe";
import { ServiceSpeedPipe } from "../../../../helpers/service-speed-pipe/service-speed-pipe";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { IpSubscriptionDetails } from "../../types";
import { SubscriptionViewBase } from "../subscription-view-base";
import { IpShortCutMenu } from "./components/ip-shortcut-menu/ip-shortcut-menu";

@Component({
  selector: "ip-subscription-view",
  templateUrl: "ip-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    EnabledPipe,
    IpShortCutMenu,
    Networkgraph,
    PageTabComponent,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    SubscriptionDetailHeader,
    IpDetailContainer,
    ThirdPartyServiceIdsRowContentComponent,
    TrafficLineChart,
    TranslatePipe,
  ],
})
export class IpSubscriptionViewComponent extends SubscriptionViewBase<IpSubscriptionDetails> {
  protected serviceSpeed = computed(() => this.subscription().serviceSpeed);
  protected domain = computed(() => this.subscription().domain);
  protected ipRoutingType = computed(() => this.subscription().ipRoutingType);
  protected surfcertFilter = computed(() => this.subscription().ipss.surfcertFilter);
  protected asn = computed(() => this.subscription().ipss.asn);
  protected topology = computed(() => this.subscription().topology ?? []);

  protected isIpBgp = computed(() => this.productTag() === "IPBGP");

  private translate = inject(TranslateService);
  protected chartSubjects = computed(() => buildIpChartSubjects(this.subscription(), this.translate));
}

export function buildIpChartSubjects(
  subscription: IpSubscriptionDetails,
  translate: TranslateService,
): TrafficSubject[] {
  const portTitle = translate.instant("ServiceElement.Port");

  const portItems = subscription.saps
    .filter((sap) => !!sap.port)
    .map((sap, index) => ({
      subscriptionId: subscription.subscriptionId,
      subscriptionInstanceIds: [sap.subscriptionInstanceId],
      name: `${portTitle} ${index + 1} - ${sap.port?.description}`,
    }));

  const allPortsItem = {
    subscriptionId: subscription.subscriptionId,
    subscriptionInstanceIds: portItems.flatMap((item) => item.subscriptionInstanceIds ?? []),
    name: translate.instant("Chart.AllPorts"),
  };

  return [allPortsItem, ...portItems];
}
